import { api } from "@/api";
import type { EngagementFilters, EngagementResponse, EngagementSummaryResponse } from "@/types/engagement";
import { toEngagementQueryParams } from "./queryParams";

export const fetchEngagement = async (filters: EngagementFilters): Promise<EngagementResponse> => {
  const response = await api.get<EngagementResponse>("/engagement", {
    params: toEngagementQueryParams(filters, 20),
  });
  return response.data;
};

export const fetchEngagementSummary = async (
  filters: Pick<EngagementFilters, "companyIds" | "userIds" | "from" | "to" | "types" | "search">
): Promise<EngagementSummaryResponse> => {
  const response = await api.get<EngagementSummaryResponse>("/engagement/summary", {
    params: toEngagementQueryParams(filters),
  });
  return response.data;
};
